import axios, { AxiosError, AxiosResponse } from "axios"
import axiosRetry from "axios-retry"

import AuthService from "@/services/Auth"

import apiConfig from "@/config/api"

type RawRequestOptions = Pick<RequestInit, "method" | "signal" | "headers"> & {
	body: Record<string, unknown>
}

export const makeRawApiRequest = async (baseUrl: string, path: string, options: RawRequestOptions): Promise<Response> => {
	const enrichedOptions = {
		...options,
		...{
			credentials: "include",
			body: JSON.stringify(options?.body)
		}
	} as RequestInit

	const urlWithPath = `${baseUrl}${path}`

	const response = await fetch(urlWithPath, enrichedOptions)

	if (!response.ok) {
		const axiosError = new Error(response.statusText) as AxiosError

		axiosError.response = {
			data: await response.json(),
			status: response.status,
			statusText: response.statusText,
			headers: response.headers
		} as AxiosResponse

		throw axiosError
	}

	return response
}

export const makeRawInboxAdminApiRequest = async (path: string, options: RawRequestOptions): Promise<Response> => {
	return await makeRawApiRequest(apiConfig.inboxAdminApiUrl as string, path, {
		...options,
		headers: {
			[AuthService.authAdminTokenKey]: AuthService.authAdminTokenKey
		}
	})
}

export const AccountAdminApi = axios.create({
	baseURL: apiConfig.accountAdminApiUrl,
	withCredentials: true
})

axiosRetry(AccountAdminApi, {
	retries: 5,
	retryDelay: (retryCount) => 1000 * retryCount
})

AccountAdminApi.interceptors.request.use(config => {
	config.headers[AuthService.authAdminTokenKey] = AuthService.authAdminTokenKey

	return config
})

export const InboxAdminApi = axios.create({
	baseURL: apiConfig.inboxAdminApiUrl,
	withCredentials: true
})

axiosRetry(InboxAdminApi, {
	retries: 5,
	retryDelay: (retryCount) => 1000 * retryCount
})

InboxAdminApi.interceptors.request.use(config => {
	config.headers[AuthService.authAdminTokenKey] = AuthService.authAdminTokenKey

	return config
})

export const InboxWhatsappChannelApi = axios.create({
	baseURL: apiConfig.inboxWhatsappChannelApiUrl,
	withCredentials: true
})

axiosRetry(InboxWhatsappChannelApi, {
	retries: 5,
	retryDelay: (retryCount) => 1000 * retryCount
})

InboxWhatsappChannelApi.interceptors.request.use(config => {
	config.headers[AuthService.authAdminTokenKey] = AuthService.authAdminTokenKey

	return config
})
